import { postGenerateVariations } from '../services';
export const generateVariationsData = async (params) => {
    const response = await postGenerateVariations(params);
    const messages = response.data?.data || [];
    return formatResponse(messages);
};
const formatResponse = messages => {
    return messages.map((item) => item.message);
};
